import { isNil, omitBy } from 'lodash';

export const Endpoint = () => `/api/v4/archive/collection/`;

export const QueryKey = (payload?: Payload) => ['v4', 'archive', 'collection', omitBy(payload, isNil)] as const;

export type Payload = {
    type: string;
};

export type Response = File;
